module.exports = __webpack_public_path__ + "components/country-flag/static/ax-8ad3be18676044f4f8a8de5014d69e8a.svg";